/**
 * @see https://confluence.mheducation.com/display/DA/External+Identifier+Standards
 */
export class XID {
    constructor(xid) {
        this.SEPERATOR = ':';
        const [xidType, systemName, serviceName, partitionName, entityTypeName, localIdentifier, versionIdentifier,] = xid.split(this.SEPERATOR);
        this.xidType = xidType;
        this.systemName = systemName;
        this.serviceName = serviceName;
        this.partitionName = partitionName;
        this.entityTypeName = entityTypeName;
        this.localIdentifier = localIdentifier;
        this.versionIdentifier = versionIdentifier;
    }
}
